import { __assign } from 'tslib';
import React__default from 'react';
import { Box } from '@mui/material';
import { green, orange } from '@mui/material/colors';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

var StateDot = function (props) {
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(Box, __assign({}, props, { className: clsx("StateDot"), title: "".concat(t("components.statedot.title"), " : ").concat(props.isFinalizedAdminState
            ? t("components.statedot.complete")
            : t("components.statedot.incomplete")), sx: __assign(__assign({}, props.sx), { height: "12px", width: "12px", borderRadius: "50%", backgroundColor: props.isFinalizedAdminState ? green[500] : orange[500] }) })));
};

export { StateDot as default };
//# sourceMappingURL=index.js.map
